// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"09f4b0c6","703":"85ce138e","787":"d7c6523c"}[chunkId] + ".chunk.js";
};